import { DISCOUNT_EXPERIMENT_FR } from 'shared/experiments/consts'
import {
  activateExperiment,
  getExperimentOnClient,
} from 'shared/experiments/utils/experiments'

const eventsTracking = () => {
  const experiment = getExperimentOnClient(DISCOUNT_EXPERIMENT_FR)
  if (experiment.isEnabled) {
    void activateExperiment(DISCOUNT_EXPERIMENT_FR)
  }
}

export default eventsTracking
